import { useCallback, useRef } from 'react';
export default function useUndoRedo(editorRef, capture, restore) {
 const history=useRef([]), index=useRef(-1), applying=useRef(false), latest=useRef({capture,restore}); latest.current={capture,restore};
 const snapshot=useCallback(()=>{
  if(applying.current)return;
  const state=latest.current.capture ? latest.current.capture() : {body:editorRef.current?.innerHTML||''};
  const serialized=JSON.stringify(state); if(history.current[index.current]===serialized)return;
  history.current=history.current.slice(0,index.current+1); history.current.push(serialized); history.current=history.current.slice(-30); index.current=history.current.length-1;
 },[editorRef]);
 const apply=useCallback(next=>{
  if(next<0||next>=history.current.length)return;
  applying.current=true; index.current=next; const value=JSON.parse(history.current[next]);
  if(latest.current.restore)latest.current.restore(value);else if(editorRef.current)editorRef.current.innerHTML=value.body;
  setTimeout(()=>{applying.current=false;},0);
 },[editorRef]);
 const undo=useCallback(()=>{snapshot();apply(index.current-1);},[snapshot,apply]);
 const redo=useCallback(()=>apply(index.current+1),[apply]);
 const reset=useCallback(()=>{history.current=[];index.current=-1;snapshot();},[snapshot]);
 return {snapshot,undo,redo,reset};
}
